export enum InvestmentOrderType {
  SUBSCRIPTION = 'SUBSCRIPTION',
  RESCUE = 'RESCUE'
}

export type InvestmentClient = {
  clientId: number
  statusId: number
  isTutorialCompleted: boolean
  Client?: {
    legalName: string
    Accounts: [
      {
        number: string
      }
    ]
  }
}

export interface InvestmentOrder {
  lastExternalStatus?: string
  externalId?: string
  id: number
  type: InvestmentOrderType
  amount: number
  operatedAmount?: number
  createdAt: Date
  updatedAt?: Date
  investmentClientId?: number
  movementId?: number | null
  statusId: number
  InvestmentClient?: InvestmentClient
}

export enum InvestmentStatus {
  'Executed' = 1,
  'Pending' = 2,
  'Rejected' = 3,
  'ManualAction' = 4,
  'NotSendedInvera' = 5,
  'Canceled' = 6
}
